import _extends from '@babel/runtime/helpers/extends';
import { Typography } from '@archer-technologies/ui-components';
import { TableHeaderRow, Table } from '@devexpress/dx-react-grid-material-ui';
import { createElement } from 'react';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import { Plugin, Getter, Template, TemplateConnector } from '@devexpress/dx-react-core';
import TableCell from '@mui/material/TableCell';
var pluginDependencies = [{
  name: 'Table'
}];

var ImagePlugin = function ImagePlugin(_ref) {
  var translate = _ref.translate,
      imageValue = _ref.imageValue,
      imagePath = _ref.imagePath;
  var image;

  if (imageValue) {
    var src = imagePath + imageValue;
    var imageName = src;
    var slashIndex = src.lastIndexOf('/');

    if (slashIndex > -1) {
      imageName = src.substring(slashIndex + 1);
    }

    var imageProps = {
      src: src,
      height: 17
    };
    image = /*#__PURE__*/createElement("img", _extends({
      alt: imageName,
      width: "100%"
    }, imageProps));
  }

  return /*#__PURE__*/createElement(Plugin, {
    name: "ImageColumn",
    dependencies: pluginDependencies
  }, /*#__PURE__*/createElement(Getter, {
    name: "tableColumns",
    computed: function computed(_ref2) {
      var tableColumns = _ref2.tableColumns;
      return [].concat(_toConsumableArray(tableColumns), [{
        type: 'image',
        key: Symbol('Image').toString()
      }]);
    }
  }), /*#__PURE__*/createElement(Template, {
    name: "tableCell",
    predicate: function predicate(_ref3) {
      var tableColumn = _ref3.tableColumn,
          tableRow = _ref3.tableRow;
      return tableColumn.type === 'image' && tableRow.type === TableHeaderRow.ROW_TYPE;
    }
  }, /*#__PURE__*/createElement(TemplateConnector, null, function () {
    return /*#__PURE__*/createElement(TableCell, null, /*#__PURE__*/createElement(Typography, {
      variant: "h6",
      color: "textPrimary"
    }, translate('cmmn:image')));
  })), /*#__PURE__*/createElement(Template, {
    name: "tableCell",
    predicate: function predicate(_ref4) {
      var tableColumn = _ref4.tableColumn,
          tableRow = _ref4.tableRow;
      return tableColumn.type === 'image' && tableRow.type === Table.ROW_TYPE;
    }
  }, /*#__PURE__*/createElement(TemplateConnector, null, function () {
    return /*#__PURE__*/createElement(TableCell, null, image);
  })));
};

export { ImagePlugin };